export default __webpack_public_path__ + "static/media/csv-download.8e79a7c1.svg";